<template>
	<div v-if="tabList.length" class="mobile-tab">
		<span
			:class="activeValue == item.value && 'tab-active'"
			v-for="(item, index) in tabList"
			:key="index"
			@click="handleTabChange(item)"
			>{{ item.label }}</span
		>
	</div>
</template>

<script setup>
defineProps({
	tabList: {
		type: Array,
		default: () => []
	},
	activeValue: {
		type: [String, Number],
		default: ''
	}
});

const emit = defineEmits(['change']);

const handleTabChange = item => {
	emit('change', item);
};
</script>

<style lang="less" scoped>
.mobile-tab {
	margin-bottom: 16px;
	display: flex;
	gap: 24px;
	span {
		padding-bottom: 6px;
		position: relative;
		color: var(--t-secondary-color, #4e5969);
		font-size: 14px;
		font-weight: 400;
		line-height: 18px; /* 128.571% */
		cursor: pointer;
	}
	.tab-active {
		font-size: 16px;
		color: var(--t-emphasis-color, #1d2129);
		font-weight: 500;
		&::before {
			content: '';
			width: 8px;
			height: 2px;
			border-radius: 8px;
			background: var(--t-emphasis-color, #1d2129);
			position: absolute;
			bottom: -2px;
			left: 50%;
			margin-left: -4px;
		}
	}
}
</style>
